import * as URI from 'urijs';
import * as Autolinker from 'autolinker';
import { MediaType, MediaDocument } from '../../media-document.model';
import { ICONOCLAST_URL } from '../content-document-adapter.config';

export class ContentDocumentProductReviewAdapter {
    static toContentDocument(document: any): MediaDocument {
        let contentDocument = new MediaDocument(document);

        contentDocument.documentId = document.documentId;
        contentDocument.isHosted = document.isHosted;
        contentDocument.authors = document.authors;
        contentDocument.body = Autolinker.link(document.matchSentence || document.tagContextMatchSentence || document.body);
        contentDocument.date = document.date;
        contentDocument.dupDocs = [];
        contentDocument.dupDocsCount = document.dupDocsCount;
        contentDocument.dupDocsIdsRemaining = document.remainingDupDocsIds;
        contentDocument.keywords = document.keywords || document.tagContextKeywords;
        contentDocument.mediaType = MediaType.ProductReview;
        contentDocument.mediaTypeIcon = document.mediaTypeIcon || contentDocument.mediaType;
        contentDocument.provider = document.provider;
        contentDocument.sentiment = document.isSentimentModified ? document.originalSentiment : document.sentiment;
        contentDocument.sentimentOverride = document.isSentimentModified ? document.sentiment : '';
        contentDocument.sourceAvatarRounded = true;
        contentDocument.sourceAvatarImgUrl = document.sourceUrl ? `${ICONOCLAST_URL}/favicon?size=48&url=${new URI(document.sourceUrl).origin()}` : '';
        contentDocument.sourceAvatarLinkUrl = document.url || document.redirectUrl;
        contentDocument.sourceCountryCode = document.country || document.countryCode;
        contentDocument.sourceName = document.source || 'Unknown';
        contentDocument.sourceNameUrl = document.sourceUrl;
        contentDocument.tags = document.tags;
        contentDocument.language = document.language;

        return contentDocument;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/adapter/adapters/content-document-product-review.adapter.ts